import { Box } from "@mui/material";
import { ClientListHeader } from "./ClientListHeader";
import { ClientListRow } from "./ClientListRow";
import { Client } from "../../../types/apiTypes";
import { TableColumnType } from "../../../types/genereal";

const columns: TableColumnType[] = [
  {
    key: "index",
    minWidth: "48px",
    maxWidth: "48px",
    label: "",
    bgColor: "#E8ECF0",
    textAlign: "left",
  },
  {
    key: "name",
    minWidth: "150px",
    maxWidth: "100%",
    label: "Name & Email",
    textAlign: "left",
  },
  {
    key: "job_title",
    minWidth: "80px",
    maxWidth: "210px",
    label: "Job Title",
    textAlign: "left",
  },
  {
    key: "company_name",
    minWidth: "80px",
    maxWidth: "210px",
    label: "Company Name",
    textAlign: "left",
  },
  {
    key: "company_domain",
    minWidth: "80px",
    maxWidth: "210px",
    label: "Company Domain",
    textAlign: "left",
  },
  {
    key: "notes",
    minWidth: "60px",
    maxWidth: "60px",
    label: "Notes",
    textAlign: "left",
  },
  {
    key: "added",
    minWidth: "110px",
    maxWidth: "110px",
    label: "Added",
    textAlign: "right",
  },
  {
    key: "menu",
    minWidth: "48px",
    maxWidth: "48px",
    label: "",
    textAlign: "left",
  },
];

type Props = {
  clients: Client[];
  isNoClient?: boolean;
};

const emptyList = [
  {
    company_domain: "--",
    company_name: "--",
    created_at: "--",
    email: "--",
    first_name: "",
    id: "1",
    job_title: "--",
    last_name: "",
    notes: "",
    updated_at: "",
  },
  {
    company_domain: "--",
    company_name: "--",
    created_at: "--",
    email: "--",
    first_name: "",
    id: "2",
    job_title: "--",
    last_name: "",
    notes: "",
    updated_at: "",
  },
  {
    company_domain: "--",
    company_name: "--",
    created_at: "--",
    email: "--",
    first_name: "",
    id: "3",
    job_title: "--",
    last_name: "",
    notes: "",
    updated_at: "",
  },
];

export const ClientList = ({ clients, isNoClient }: Props) => {
  return (
    <Box>
      <ClientListHeader columns={columns} />
      {(clients.length === 0 ? emptyList : clients).map((client, index) => (
        <ClientListRow
          key={client.id}
          columns={columns}
          row={{
            ...client,
            index: String(index + 1),
            isNoClient: isNoClient ? "" : "client",
          }}
        />
      ))}
    </Box>
  );
};
